module.exports = __webpack_public_path__ + "img/logo.41d7aa3c.png";